<template>
   <footer class="bg-footer-dark text-center py-2">
    <span class="text-text-light font-bold">
      CREAT DE <span class="text-footer-accent">ARNOLD</span> Ⓒ 2024
    </span>
  </footer>
</template>

<script>
export default {
  name: "FooterComponent",
};
</script>

<style scoped>
.bg-sidebar-dark {
  background-color: #1a1528;
}
.text-text-light {
  color: #b3b3cc;
}

.bg-footer-dark {
  background-color: #1a1528; /* Fundal închis */
}

.text-footer-accent {
  color: #a855f7; /* Culoarea mov din temă */
}
</style>
